export default "__VITE_ASSET__C$XeDCh2__"